import React from "react";
import PropTypes from "prop-types";
import ComboBox from "./ComboBox";
import { states } from "../../constants/index";
import { useTranslation } from "react-i18next";

const StateSelector = ({ name, disabled, ...comboBoxProps }) => {
  const { t } = useTranslation();

  return (
    <ComboBox
      options={[
        { label: t("validate.validateFilterShowAllOption"), value: "" },
        ...states
      ]}
      name={name}
      label={t("state")}
      InputProps={{
        inputProps: {
          "data-qa": "state-selector-input"
        }
      }}
      disabled={disabled}
      {...comboBoxProps}
    />
  );
};

StateSelector.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool
};

StateSelector.defaultProps = {
  name: "state"
};

export default StateSelector;
